/**
 * Endpoints de **Mantenimiento → Dashboard y Reportes**.
 *
 * Los dos son de sólo lectura y comparten el grupo `maintenance` del resto del
 * módulo.
 */

import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/http/api-client';

import type { DashboardMantenimiento } from './dashboard.types';
import type { ReporteFiltros, ReporteMantenimiento } from './reportes.types';

export const mantenimientoResumenKeys = {
  dashboard: ['mantenimiento', 'dashboard'] as const,
  reportes: (filtros: ReporteFiltros) => ['mantenimiento', 'reportes', filtros] as const,
} as const;

/** Cadena de consulta del informe. */
function cadenaDe(filtros: ReporteFiltros): string {
  const parametros = new URLSearchParams();

  if (filtros.desde) parametros.set('desde', filtros.desde);
  if (filtros.hasta) parametros.set('hasta', filtros.hasta);
  if (filtros.categoriaId) parametros.set('categoria_id', String(filtros.categoriaId));

  const cadena = parametros.toString();

  return cadena ? `?${cadena}` : '';
}

/** Indicadores y listas del dashboard. */
export function useDashboardMantenimiento() {
  return useQuery({
    queryKey: mantenimientoResumenKeys.dashboard,
    queryFn: ({ signal }) =>
      apiClient.get<DashboardMantenimiento>('/api/mantenimiento/dashboard', { signal }),
    staleTime: 60 * 1000,
  });
}

/** Informe del rango pedido. */
export function useReporteMantenimiento(filtros: ReporteFiltros) {
  return useQuery({
    queryKey: mantenimientoResumenKeys.reportes(filtros),
    queryFn: ({ signal }) =>
      apiClient.get<ReporteMantenimiento>(
        `/api/mantenimiento/reportes${cadenaDe(filtros)}`,
        { signal },
      ),
  });
}
